<template>
  <div class="change-password-page">
    <div class="page-container">
      <div class="user-center">
        <user-center-sidebar active="change-password" :user-info="userInfo"></user-center-sidebar>

        <!-- 主内容区 -->
        <section class="user-main">
          <div class="user-card" style="max-width: 520px">
            <div class="card-title">
              <h2>修改登录密码</h2>
              <span class="extra">需先输入当前密码</span>
            </div>

            <el-form :model="form" :rules="rules" ref="form" class="password-form">
              <el-form-item prop="oldPassword">
                <el-input
                  v-model="form.oldPassword"
                  :type="showOldPassword ? 'text' : 'password'"
                  placeholder="请输入当前密码"
                >
                  <template slot="prepend">当前密码</template>
                  <i slot="suffix"
                    :class="showOldPassword ? 'el-icon-view' : 'el-icon-view'"
                    @click="showOldPassword = !showOldPassword"
                    style="cursor: pointer"
                  ></i>
                </el-input>
              </el-form-item>

              <el-form-item prop="newPassword">
                <el-input
                  v-model="form.newPassword"
                  :type="showNewPassword ? 'text' : 'password'"
                  placeholder="6-32位字母/数字/符号"
                >
                  <template slot="prepend">新密码</template>
                  <i slot="suffix"
                    :class="showNewPassword ? 'el-icon-view' : 'el-icon-view'"
                    @click="showNewPassword = !showNewPassword"
                    style="cursor: pointer"
                  ></i>
                </el-input>
              </el-form-item>

              <el-form-item prop="confirmPassword">
                <el-input
                  v-model="form.confirmPassword"
                  :type="showConfirmPassword ? 'text' : 'password'"
                  placeholder="再次输入新密码"
                >
                  <template slot="prepend">确认新密码</template>
                  <i slot="suffix"
                    :class="showConfirmPassword ? 'el-icon-view' : 'el-icon-view'"
                    @click="showConfirmPassword = !showConfirmPassword"
                    style="cursor: pointer"
                  ></i>
                </el-input>
              </el-form-item>

              <el-form-item>
                <div class="form-actions">
                  <el-button type="primary" @click="handleSubmit" :loading="loading">
                    提交修改
                  </el-button>
                  <el-button @click="handleReset">重置</el-button>
                </div>
              </el-form-item>
            </el-form>

            <div class="form-tip">
              <i class="el-icon-info"></i>
              提示：修改成功后需要使用新密码重新登录。密码建议包含大小写字母 + 数字 + 符号，并避免与其他网站相同。
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentUser, logout } from '@/utils/auth'
import UserCenterSidebar from '@/components/UserCenterSidebar'

export default {
  name: 'ChangePassword',
  components: {
    UserCenterSidebar
  },
  data () {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.form.newPassword) {
        callback(new Error('两次新密码输入不一致'))
      } else {
        callback()
      }
    }
    return {
      userInfo: {},
      showOldPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      loading: false,
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入当前密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 32, message: '新密码须为6-32位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.$bus.$on('login-success', this.handleLoginSuccess)
    this.checkLogin()
  },
  methods: {
    checkLogin () {
      const user = getCurrentUser()
      if (!user) {
        this.$bus.$emit('open-login')
        return false
      }
      this.userInfo = user
      return true
    },
    handleLoginSuccess () {
      if (getCurrentUser()) this.checkLogin()
    },
    handleSubmit () {
      this.$refs.form.validate(valid => {
        if (!valid) return

        this.loading = true
        this.$http({
          url: this.$http.adornUrl('/crmapi/p/loginAccount/updatePasswordById'),
          method: 'post',
          data: {
            password: this.form.oldPassword,
            newPassword: this.form.newPassword,
            confirmPassword: this.form.confirmPassword
          }
        }).then(({ data }) => {
          if (data && data.code === 'C0000') {
            this.$message.success(data.message || '密码修改成功，请重新登录')
            setTimeout(() => {
              logout()
            }, 1000)
          } else {
            this.$message.error((data && data.message) || '修改失败')
          }
        }).finally(() => {
          this.loading = false
        })
      })
    },
    handleReset () {
      this.$refs.form.resetFields()
    }
  },
  beforeDestroy () {
    this.$bus.$off('login-success', this.handleLoginSuccess)
  }
}
</script>

<style lang="scss" scoped>
.change-password-page {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 20px;
}

.page-container {
  max-width: 1200px;
  margin: 0 auto;
}

.user-center {
  display: flex;
  gap: 20px;
}

.user-main {
  flex: 1;

  .user-card {
    background: #fff;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

    .card-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;
      padding-bottom: 16px;
      border-bottom: 1px solid #f0f0f0;

      h2 {
        font-size: 18px;
        color: #333;
        margin: 0;
      }

      .extra {
        font-size: 13px;
        color: #999;
      }
    }
  }
}

.password-form {
  .el-form-item {
    margin-bottom: 24px;
  }

  .el-input {
    .el-input-group__prepend {
      width: 100px;
      text-align: center;
    }
  }
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 8px;
}

.form-tip {
  margin-top: 24px;
  padding: 14px;
  background: #fff7e8;
  border: 1px solid #ffe7ba;
  border-radius: 8px;
  font-size: 13px;
  color: #ad6800;
  line-height: 1.6;

  i {
    margin-right: 6px;
  }
}

@media screen and (max-width: 768px) {
  .user-center {
    flex-direction: column;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/changePassword.vue